import { createAction } from '@reduxjs/toolkit';

export const setNextStep = createAction('step/setNextStep');
export const setPrevStep = createAction('step/setPrevStep');
export const setDisableStep = createAction('step/setDisableStep');
export const setEnableStep = createAction('step/setEnableStep');
export const setLoadingNextStep = createAction('step/setLoadingNextStep');
